// extracted by mini-css-extract-plugin
module.exports = {"label":"TextBox_label__hPiGJ","textbox":"TextBox_textbox__3uXZ1","error":"TextBox_error__2MB73"};